import React, {Component, useState, useEffect } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import './detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from './../../config/api';
// import Const from './../../config/const';
// import Tool from './../../utils/tool';
// import Error from './../../utils/error';
// import {connect} from 'react-redux';
// import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
import tools from '@/utils/tool';
import audioPlayIcon from '@/assets/audio_play_icon.png'
import audioPauseIcon from '@/assets/audio_pause_icon.png'
import audioSliderCircleIcon from '@/assets/slider_circle_icon.png'
import { Slider, WingBlank, WhiteSpace } from 'antd-mobile';
import jt from '../../assets/jt.png'
import gb from '../../assets/gb.png'
import dk from '../../assets/dk.png'
import dingyue from '../../assets/dingyue.png'
const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT', // 图文
  VIDEO: 'VIDEO', // 视频
  SWIPER: 'SWIPER' // 图说
}

// @connect(
//   state => ({admin: state.admin}),
//   {refresh_admin}
// )
var setin = null;
class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {},
      type: DETAIL_TYPE.PICTEXT, // 稿件类型，默认图文稿件
      curSwiperText: '',
      curSwiperIndex: 1,
      name: '',
      from:'', // 判断该文章来源 如来源是文明实践 赋值为civilization 否则为常规东城文章来源
      playSpeedAry:['1','1.25','1.5','2'], // 播放速度
      curSelectSpeed:'', // 当前选择的倍数
      audioPlayStatus:false,
      audioDuration:'', // 音频总时长
      audioCurTime:0,
      //notStarted：未开始 start：开始 suspend：暂停 end：结束
      stateName: 'notStarted',
      playerName: '',
      videoPlayer: null, //新增解决视频不刷新的问题（跳转后视频还在播放）
      titleSwitch: false,
      show: false, //描述展开收起
      recommendList: [], //相关推荐列表
      showElem: true,
      duration: props.duration,
      formattedDuration: '',
    };

  }

  componentWillMount() {
    console.log(this.props)
    let url = window.location.href
    let parameter =  tools.getParams(url)
    console.log(parameter, 'param')
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid,
      from: parameter.from
    },() => {
      // this.getList()
      // 根据内容
      this.getContentId();
      // 统计
      this.statistics();
    })

  }

  componentDidMount() {
    this.initSwiper();
    
    // this.weiXinLink()
    // this.formatDuration();
    // const didMountId = this.props.location.query.id;
    // this.setState({ id: didMountId }, () => {
    //   this.props.pageList({ id: this.state.id }); // 请求接口获取数据
    // });
  }
  // 路由的参数由于是在componentDidMount中获取的，如果在详情页面再次打开详情页面，由于组件并没有重新渲染，导致didMount不会获取路由参数。
  // 因此在参数改变的时候，可以利用componentWillReceiveProps来更新变量。
  //组件更新时被调用 
  componentWillReceiveProps(newProps) {
    // if (newProps.location.query.id !== this.state.id) {
    //   this.setState({ id: newProps.location.query.id},  () => {
    //     this.props.pageList({ id: this.state.id});  //当路由参数改变时，重新请求接口获取数据
    //   });
    // }
    setin && clearInterval(setin)
    this.state.videoPlayer && this.state.videoPlayer.dispose()
    this.setState({
      uuid: '',
      data: {},
      type: DETAIL_TYPE.PICTEXT, // 稿件类型，默认图文稿件
      curSwiperText: '',
      curSwiperIndex: 1,
      name: '',
      from:'', // 判断该文章来源 如来源是文明实践 赋值为civilization 否则为常规东城文章来源
      playSpeedAry:['1','1.25','1.5','2'], // 播放速度
      curSelectSpeed:'', // 当前选择的倍数
      audioPlayStatus:false,
      audioDuration:'', // 音频总时长
      audioCurTime:0,
      //notStarted：未开始 start：开始 suspend：暂停 end：结束
      stateName: 'notStarted',
      playerName: '',
      videoPlayer: null, 
      titleSwitch: false,
      show: false, //描述展开收起
      recommendList: [], //相关推荐列表
      showElem: true,
      formattedDuration: '',
    })
    console.log(this.props)
    let url = window.location.href
    let parameter =  tools.getParams(url)
    console.log(parameter, 'param')
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid,
      from: parameter.from,
      showElem: false,
    },() => {
      // this.getList()
      // 根据内容
      this.getContentId();
      // 统计
      this.statistics();
      setTimeout(() => {
        this.setState({
          showElem: true,
        })
      }, 0)
    })
   
  }

  componentWillUnmount() {
    setin&&clearInterval(setin)
  }

  // shouldComponentUpdate() {
  //
  // }
  // 初始化视频播放器
  initPlayer = (data) => {
    
    var player = new window.Aliplayer({
      "id": "player-con",
      "source": data.ext_data.video_url,
      "width": "100%",
      height: "100%",
      "autoplay": false,
      "isLive": false,
      "rePlay": false,
      "playsinline": true,
      "preload": false,
      cover: data.cover,
      "controlBarVisibility": "hover",
      "useH5Prism": true,
      "skinLayout": [
        {
          "name": "bigPlayButton",
          "align": "blabs",
          "x": 30,
          "y": 80
        },
        {
          "name": "H5Loading",
          "align": "cc"
        },
        {
          "name": "errorDisplay",
          "align": "tlabs",
          "x": 0,
          "y": 0
        },
        {
          "name": "infoDisplay"
        },
        {
          "name": "tooltip",
          "align": "blabs",
          "x": 0,
          "y": 56
        },
        {
          "name": "thumbnail"
        },
        {
          "name": "controlBar",
          "align": "blabs",
          "x": 0,
          "y": 0,
          "children": [
            {
              "name": "progress",
              "align": "blabs",
              "x": 0,
              "y": 44
            },
            {
              "name": "playButton",
              "align": "tl",
              "x": 15,
              "y": 12
            },
            {
              "name": "timeDisplay",
              "align": "tl",
              "x": 10,
              "y": 7
            },
            {
              "name": "fullScreenButton",
              "align": "tr",
              "x": 10,
              "y": 12
            },
            {
              "name": "volume",
              "align": "tr",
              "x": 5,
              "y": 10
            }
          ]
        }
      ]
    }, function (player) {
        console.log("The player is created");
      }
    );
    this.setState({
      videoPlayer: player
    })
  }

  //点击显示，再次点击隐藏
  MyComponent() {
    this.setState({
      show: !this.state.show,
    })
  }

  //分钟秒
  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const formattedMins = mins.toString().padStart(2, '0');
    const formattedSecs = secs.toString().padStart(2, '0');
    return (formattedMins+':'+formattedSecs);
  }
  
  //日期格式化
  dateTime = (timestamp) => {
    const currentTime = Math.floor(Date.now() / 1000);
    const timeDiff = currentTime - timestamp;
    if (timeDiff < 60) {
      return (timeDiff) + '秒前' ;
    } else if (timeDiff < 3600) {
      const minutes = Math.floor(timeDiff / 60);
      return (minutes) + '分钟前';
    } else if (timeDiff < 86400) {
      const hours = Math.floor(timeDiff / 3600);
      return (hours) + '小时前';
    } else {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return (year)+ '-' +(month)+ '-' +(day);
    }
  }

  //获取相关推荐列表
  getBoutiquelist(){
    console.log('获取相关推荐列表')
    $.ajax({
      type: 'get',
      // url: 'http://bjdcapi.bjnews.com.cn/news/boutique_video_list.php',
      // url: 'http://bjdcapi-test.bjnews.com.cn/news/boutique_video_list.php',
      url: API.boutique_video_list,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0) {
        console.log(res)
        this.setState({
          recommendList: res.data,
        })
      }else{
        Message({
          type: "warning",
          message: res.msg,
          duration: 5000,
        });
      }
    })
    .fail(() => {
      Message.error("内部服务器错误！");
    });
  };

  
  // MyComponent_link() {
  //   const history = useHistory();
  
  //   const handleClick = () => {
  //     history.push(item.row.share_url);
  //   };
  
  //   return (
  //     <a href={item.row.share_url} onClick={handleClick}>点击跳转</a>
  //   );
  // }

  getHtml() {
    const {data, type, curSwiperIndex,playSpeedAry,curSelectSpeed,audioPlayStatus,audioCurTime,audioDuration,stateName,
      recommendList,titleSwitch,} = this.state;

    switch (type) {
      case DETAIL_TYPE.PICTEXT:
        // 图文稿件
        return (
          <div className="picText-box">
            {/*题目*/}
            <div className="title" style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              'WebkitLineClamp': '2',
              'WebkitBoxOrient': 'vertical',
            }}>{data.title}
            </div>

            {/*其他信息*/}
            <div className="info-box">
              <div className="left">
                <div>{data.head_author}</div>
                {/*<div className="author-name">编辑 {data.author_name}</div>*/}
              </div>
              <div className="right">
                <div className="publish_time">{data.publish_time}</div>
              </div>
            </div>
            {/* 音频 */}
            {data.audio && data.audio.length > 0 ?
              <div className="audioWrapper">
                <audio ref='audioDom' src={data.audio[0].url} id="namet"></audio>
                <div className="audioModule">
                  <div className="leftControl">
                    <div className="timeline">
                      <div className="curTime">{tools.secondToMS(audioCurTime)}</div>
                      <div className="sliderModule">
                        <Slider
                          value={audioCurTime / 1}
                          min={0}
                          max={audioDuration / 1}
                          step={1}
                          handleStyle={{
                            height: '12px',
                            width: '12px',
                            backgroundImage: `url(${audioSliderCircleIcon})`,
                            backgroundSize:'100% 100%',     
                          }}
                          onChange={this.changeAudioSlider.bind(this)}
                        />
                      </div>
                      <div className="duration">{tools.secondToMS(audioDuration)}</div>
                    </div>
                    <div className="playSpeed">
                      播放倍数：
                      {playSpeedAry.map((item,index) => {
                        return <span className={`${item === curSelectSpeed ? 'isActive' : ''} speedItem`} 
                                     key={index}
                                     onClick={this.changeSpeed.bind(this,item)}>{`x${item}`}</span>
                      })}
                    </div>
                  </div>
                  <div className="playPause">
                    {!audioPlayStatus ?
                      <img src={audioPlayIcon} alt="" onClick={this.togglePlayStatus}/>
                    :
                      <img src={audioPauseIcon} alt="" onClick={this.togglePlayStatus}/>
                    }
                  </div>
                </div>
              </div>
            :''}
            {/*概述*/}
            {/* {data.desc ?
              <div className="desc" dangerouslySetInnerHTML={{__html: data.desc}}></div> : ''} */}
            {data.desc ?
            <div key={Date.now()} className="desc" dangerouslySetInnerHTML={{__html: data.desc}}></div> : ''}

            {/*正文*/}
            <div className="main-text"
                 dangerouslySetInnerHTML={{__html: this.replacRem(data.content)}}></div>
            {/* 投票区 */}
            {data.ballot_info ?
              <div className="voteBox">
                <p className="voteTitle">{"< 投票专区 >"}</p>
                <ul className="voteLists">
                  {data.ballot_info.question_list.map((item, index) => {
                    return <li className="votelist" key={index}>
                      {/* <p
                        className="voteList_title">{'问题' + (index + 1) + '：' + item.q_title + '(' + (item.select_num / 1 === 1 ? '单选' : '多选') + ')'}</p> */}
                      <p
                        className="voteList_title">{'问题' + (index + 1) + '：' + item.q_title}</p>
                      <ul className="optionsBox">
                        {item.option_list.map((childItem, childIndex) => {
                          return <li className="options" key={childIndex}>
                            {item.has_image / 1 === 1 ?
                              <div className="noImg_btn">{childItem.title}</div>
                              :
                              <div className="option">
                                <img src={childItem.image} alt={childItem.title}/>
                                <p className="option_title">{childItem.title}</p>
                                <button className="ballot_btn">投票</button>
                              </div>
                            }
                          </li>
                        })}
                      </ul>
                      <div className="clear"></div>
                    </li>
                  })}
                </ul>
              </div> : ''
            }

          </div>
        )
        break
      case DETAIL_TYPE.VIDEO:
        // 视频稿件
        return (
          <div className="video-box">
            <div className="video-container">
              {/* 预告 */}
              {data.live_status / 1 === 3 ?
                <div className='yugao' style={{
                  background: 'url(' + data.cover + ') no-repeat center', backgroundSize: 'cover'
                }}>
                  <div className='text'><span>{data.trailer.start_time}&nbsp;&nbsp;&nbsp;&nbsp;开始</span></div>
                </div> : ''
              }
              {/* 直播已结束 */}
              {data.live_status / 1 === 2 ?
                <div className='yugao' style={{
                  background: 'url(' + data.cover + ') no-repeat center', backgroundSize: 'cover'
                }}>
                  <div className='text'><span>直播已结束</span></div>
                </div> : ''
              }
              {data.live_status / 1 === 3 || data.live_status / 1 === 2 ?
                <div id='player-con' style={{display: 'none'}}></div> : <div id='player-con'></div>
              }
              {/* {
                this.state.showElem ? (
                  <div id='player-con'></div>
                ) : ''
              }
               */}
              {/* <video
                className={classNames("video")}
                ref="video"
                id="video"
                controls
                preload="auto"
                playsInline={true}
                x-webkit-airplay="true"
                webkit-playsinline="true"
                x5-video-player-type="h5"
                x5-video-orientation="portraint"
                x5-playsinline="true"
                poster={data.cover}>
                <source id="videoSource" ref="videoSource" src=""/>
              </video> */}
            </div>
            
            {/* 标题和介绍 */}
            <div className="video-main">
              <div className="video-title" onClick={this.MyComponent.bind(this)}>
                <div className="video-title-content">{data.title}</div>
                <div onClick={this.MyComponent.bind(this)} className={this.state.show ? 'right_downIcon' : 'title-rightIcon'}></div>
              </div>
              <div className="video-authors">{data.head_author}<span style={{marginLeft: '.2rem'}}>{data.publish_time}</span></div>
              {/* {this.state.show && <div className="video-des" dangerouslySetInnerHTML={{__html: data.desc}}></div>} */}
              {this.state.show && <div key={Date.now()} className="video-des" dangerouslySetInnerHTML={{__html: data.desc}}></div>}
            </div>
            
            {/* 分割线 */}
            <div className="empty"></div>

            {/* 相关推荐 */}
            <div className="recommend">
              {recommendList.length > 0 ? (<div className="recommend_tips">相关推荐</div>) : '' }
              {recommendList.length > 0 ? recommendList.map((item, index) => (
                <div className="recommend_list" key={index}>
                  <div className="sp_list">
                      {/* <a href={item.row.share_url} className="live_link" onClick={() => this.handleClick(item.row.share_url)}> onClickz直接在pc端就点不了 */}
                      <a href={item.row.share_url} className="live_link">
                          <h3>{item.row.title}</h3>
                          <div className="sp_img" style={{
                            background: 'url(' + item.row.big_cover + ') no-repeat center', backgroundSize: 'cover'
                            }}>
                              <div className="sp_bf"></div>
                              <div className="sp_yy">
                                  <div className="sp_sj">
                                    {this.formatTime(item.row.ext_data.duration)}
                                  </div>
                              </div>
                          </div>
                          <div className="sp_bq">
                              <span>{item.row.column_info[0].column_name}</span>
                              <span>
                                {this.dateTime(item.row.publish_timestamp)}
                                <span></span>
                              </span>
                          </div>
                      </a>
                  </div>
                </div>
              )) : ''
            }              
            </div>
          </div>
          
        )
        break;
      case DETAIL_TYPE.SWIPER:
        // 图说稿件
        return (
          <div className="sicSwiper-box">
            {
              data.desc ? (
                <div className="sicSwiper-title" style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  'WebkitLineClamp': '2',
                  'WebkitBoxOrient': 'vertical',
                }}>{data.desc}</div>
              ) : ('')
            }
            <div className="sicSwiper-container" id="subject_swiper">
              <div className="swiper-wrapper" id="subject_list">
                {
                  data.content.map((item, index) => {
                    // var suffix = Tool.getSuffix(item.cover, 500)
                    return (
                      <div className="swiper-slide" style={{
                        backgroundImage: 'url(' + item.image_url + ')'
                      }} key={index}></div>
                    )
                  })
                }
              </div>
              {/*前进后退*/}
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>
            <div className="sicSwiper-info">
              <div className="sicSwiper-num">{curSwiperIndex + 1 + '/' + data.content.length}</div>
            </div>
            <div className="sicSwiper-content">{data.content[curSwiperIndex].desc}</div>
          </div>
        )
        break;
        case DETAIL_TYPE.AUDIO:

          // 音频稿件
          // stateName : notStarted开始前 start开始 suspend暂停 end结束
          return(
            <div className="audio-box">
              <div className="vid_top" style={{
                backgroundImage: 'url(' + data.cover + ')', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'
              }}>
                <div className="in_top">
                    <div className={"in_bai_z " + (stateName === 'notStarted' || stateName === 'suspend' || stateName === 'end' ? 'in_bai_z_jiaozheng' : stateName === 'start' ? 'in_bai_z_jiao' : '')}></div>
                    <div className="in_top_xian">
                        <div className={"in_top_changp " + (stateName === 'start' ? 'in_xuanz_cp' : 'in_xuanz_cp pause')}> 
                        </div>
                        {stateName === 'notStarted' || stateName === 'suspend' ? <div className="in_top_bf" onClick={this.audioStart}></div> : ''}
                        {stateName === 'start' ? <div className="in_top_zt" onClick={this.audioSuspend}>
                            <div className="in_top_zt_dx lundong_cla"></div>
                        </div> : ''}
                        
                        {stateName === 'end' ? <div className="in_top_cb" onClick={this.audioStart}></div> : ''}
                    </div>
                </div>
                <div  className="prism-player" id="J_prismPlayer" style={{display:'none'}}></div>
                <div className="in_tuola">
                    <div className="in_tuola_left">0:00</div>
                    <div className="in_tuola_cen">
                        <div className="in_tuola_jindu">
                            <div className="in_tuola_jindu_xian"></div>
                            <div className="in_tuola_jindu_dian"></div>
                        </div>
                    </div>
                    <div className="in_tuola_right"></div>
                </div>
              </div>
              <div className="box_daxinjingb" onClick={this.openApp1}><span style={{paddingRight: '0.1rem'}}>打开北京东城，大家一起听</span><img src={jt} style={{width:'0.26rem', height:'0.26rem', marginTop: '-3px'}} alt=""/> </div>

              <div className="min">
                <div className="box_title">
                    <div style={{fontWeight: '700'}} onClick={this.titleSwitchFun}>{data.title}</div><div className="anniu"><img className={!titleSwitch? 'gb' : ''} src={gb} alt="" /><img className={titleSwitch? 'gb' : ''} src={dk} alt=""/></div>
                </div>
                <div className="box_jizhe">
                    <span className="authortt">{data.head_author} </span>
                    <span className="timett"> {data.publish_time}</span>
                </div>
                <div className="article_s" style={!titleSwitch ? {display: 'none'} : {}}>
                    <p>{data.desc}</p>
                </div>
                <div className="invideo">
                  <div className="tips">
                      <span>进入</span><span style={{color: '#d02d2d',margin: '0 0.2rem',}} className="dakai" onClick={this.openApp1}>栏目</span><span>阅读更多内容</span>
                  </div>
                  <div className="subscribe">
                      <div><img src={dingyue} alt="" /></div>
                      <div className="subscribe_tit dakai" onClick={this.openApp1}>订阅</div>
                  </div>
                </div>
            
              </div>
              
            </div>
          )
        break;
      default:
        return ''
    }
  }

  getContentId() {
    // console.log(this.props);
    console.log('detail')
    const {uuid, type} = this.props.match.params;
    const {from} = this.state
    console.log(from)
    if (uuid && type) {
      this.state.uuid = uuid
      console.log(parseInt(type), type)
      switch (parseInt(type)) {
        case 1:             //图文
          this.setState({
            type: DETAIL_TYPE.PICTEXT,
            name: from === 'civilization' ? 'civiarticle' : 'article'
          })
          this.getContent()
          break;
        case 2:             //视频
          this.setState({
            type: DETAIL_TYPE.VIDEO
          })
          this.getVideoContent()
          this.getBoutiquelist()
          break;
        case 3:
          this.setState({    //图说
            type: DETAIL_TYPE.SWIPER,
            name: 'imageSays'
          })
          this.getSwiperContent()
          break;
        case 21:
          this.setState({    //音频
            type: DETAIL_TYPE.AUDIO,
            name: 'audio'
          })
          this.getAudioContent()
          break
      }
    } else {
      this.props.history.push('/');
      return
    }
  }
  // 获取图文稿件内容
  getContent() {
    let url = API.manuscript_detail
    if(this.state.from === 'civilization'){
      url = API.civ_manuscript_detail
    }
    let _this = this
    $.ajax({
      type: 'get',
      url: url,
      async: false,
      headers: {
        version: 'v101'
      },
      data: {
        uuid: this.state.uuid,
        client_type: 'wap',
        // model : 'ios'
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          // 图文稿件内包含视频时
          if (this.state.type === DETAIL_TYPE.VIDEO) {
            // this.playVideo(res.data.ext_data.video_url)
            this.initPlayer(res.data)
          } 
          // 图文稿件内包含音频时
          if(res.data.audio.length > 0){
            let audioEle = this.refs.audioDom
            audioEle.addEventListener("loadedmetadata", function () {
              //加载数据
              //音频的总长度
              _this.setState({
                // audioDuration: audioEle.duration,
                audioDuration: res.data.audio[0].duration,
              });
            });
            audioEle.addEventListener(
              "timeupdate",
              function () {
                var curAudioCurTime = audioEle.currentTime;
                _this.setState({
                  audioCurTime:curAudioCurTime || 0
                });
                // if (curAudioCurTime / 1 >= _this.state.audioDuration / 1) {
                //   _this.setState({
                //     audioPlayStatus:false
                //   })
                // }
              },
              false
            );
            audioEle.addEventListener('ended',function(){
              _this.setState({
                audioPlayStatus:false
              })
            })
          }
          this.allaudio()
          this.replaceHref()
        })
        document.title = res.data.title;
        this.initWx({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }
  // 获取视频稿件内容
  getVideoContent() {
    console.log("-------------------")
    const {type, uuid, videoType} = this.props.match.params;
    if (!videoType) {
      this.props.history.push('/');
      return
    }
    if (videoType / 1 === 2) { //视频
      this.setState({
        name: 'video'
      })
    } else if (videoType / 1 === 6) {  //直播
      this.setState({
        name: 'live'
      })
    }
    let url = API.video_detail
    if(this.state.from === 'civilization'){
      url = API.civ_video_detail
    }
    const data = {
      uuid: this.state.uuid,
      type: videoType,
    }
    if (videoType / 1 === 2) {
      data.client_type = 'wap'
    }
    $.ajax({
      type: 'get',
      url: url,
      async: false,
      data: data,
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          // this.playVideo(res.data.ext_data.video_url)
          // this.replaceHref()
          this.initPlayer(res.data)
        })
        document.title = res.data.title;

        this.initWx({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }
  // 获取图说稿件内容
  getSwiperContent() {
    let url = API.graph_article_detail
    // 稿件来源是文明实践时
    if(this.state.from === 'civilization'){
      url = API.civ_graph_article_detail
    }
    $.ajax({
      type: 'get',
      url: url,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          this.replaceHref()
          // 数据加载完成后初始化 Swiper
          this.initSwiper(); 
        })
        var cur = res.data.content[0];
        var cur_w = parseFloat(cur.width);
        var cur_h = parseFloat(cur.height);
        var h = cur_h / cur_w * 7.5
        $('#subject_swiper').css({
          height: h + 'rem'
        })
        document.title = res.data.title;

        this.initWx({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }
  // 获取音频稿件内容
  getAudioContent() {
    console.log('获取音频稿件内容')
    let url = API.audio_detail
    // // 稿件来源是文明实践时
    // if(this.state.from === 'civilization'){
    //   url = API.audio_detail
    // }
    $.ajax({
      type: 'get',
      url: url,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        console.log(res)
        this.setState({
          data: res.data
        },()=>{ 
          let urlname = this.state.data.ext_data && this.state.data.ext_data.audio_url || '';
          // console.log(this.state.data.ext_data.audio_url)
          this.aliPla(urlname)
        })
        document.title = res.data.title;

        this.initWx({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        this.aliPla('')
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }
  

  aliPla(url) {
    console.log(123)
    var _this = this
    var player = new window.Aliplayer({
      "id": "J_prismPlayer",
      // "source": 'https://bjdc-test.oss-cn-beijing.aliyuncs.com/audio/2023/06/14/5332983622616461779.mp3',
      "source": url,
      "width": "0px",
      "height": "0px",
      "autoplay": false,
      "isLive": false,
      "rePlay": false,
      "playsinline": true,
      "preload": true,
      "controlBarVisibility": "hover",
      "useH5Prism": true,
      "mediaType": "audio"
    }, function (player) {
        window.player_getDur = player.getDuration();
    });
    this.setState({
      playerName: player
    })
    // player.play();
    // return window.player
    player.on('ready', function(e) {
      // player.play();
      var player_getDur = player.getDuration();
      var ddd=Math.floor(player_getDur%3600);
      //  Math.floor(getCurrentTime/3600) + "时" + 
      var fff =Math.floor(ddd/60) + ":"+ (Math.round(player_getDur%60) < 10 ? '0' + Math.round(player_getDur%60) : Math.round(player_getDur%60));
      document.getElementsByClassName('in_tuola_right')[0].innerText = fff;
    });
    player.on("ended", function(e){
        const {stateName} = _this.state;
        // if(stateName === 'notStarted'){
          _this.setState({
            stateName: 'end'
          })
        // }else if(stateName === 'start'){
        //   this.setState({
        //     stateName: 'suspend'
        //   })
        // }else {
        //   this.setState({
        //     stateName: 'start'
        //   })
        // }
        setin&&clearInterval(setin)
        var player_getDur = player.getDuration();
        // console.log(player_getDur)
        var cdf=Math.floor(player_getDur%3600);
        //  Math.floor(getCurrentTime/3600) + "时" + 
        var fcc =Math.floor(cdf/60) + ":"+ (Math.round(player_getDur%60) < 10 ? '0' + Math.round(player_getDur%60) : Math.round(player_getDur%60));
        $('.in_tuola_left').innerText = fcc
        $('.in_tuola_jindu_xian').css('width',"4.96rem");
        $('.in_tuola_jindu_dian').css('left',"4.96rem");
    })
  }

  playVideo(url) {
    this.refs.videoSource.src = url;
    this.refs.video.load();
    setTimeout(() => {
      this.refs.video.play();
    }, 1000)
  }
  allaudio() {
    var _this = this;
    // var audios = document.getElementsByClassName('main-text')[0].getElementsByTagName("audio");
    // var audios = $('.main-text audio');
    var audios = $('audio');
    function pauseAll() {
        var self = this;
        console.log(self);
        [].forEach.call(audios, function (i) {
            i !== self && i.pause();
            if(i.id === "namet" && !!i.paused){
              _this.setState({
                audioPlayStatus:false
              })
            }
            // else {
            //   _this.setState({
            //     audioPlayStatus:!_this.state.audioPlayStatus
            //   })
            // }
            console.log(i !== self && i.pause())
        })
    }
    [].forEach.call(audios, function (i) {
        i.addEventListener("play",function(){
          if(i.id === "namet" && i.paused){
            _this.setState({
              audioPlayStatus: true
            })
          }
            console.log(i)
            pauseAll.bind(i)()
        }.bind(i));
    })
  }
  // 初始化图说稿件的组件
  initSwiper() {
    var _this = this;
    this.subject_swiper = new window.Swiper('#subject_swiper', {
      direction: 'horizontal',
      loop: true,
      // spaceBetween: '.15rem',//只识别px
      // slidesOffsetAfter: '.3rem',
      // slidesOffsetBefore: '.3rem',
      // observer: true,
      // observeParents: true,
      initialSlide: 0,
      touchMoveStopPropagation: true,
      preventClicksPropagation: true,
      slidesPerView: 'auto',
      freeMode: false,
      autoplay: {
				delay: 2000, 
			},

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        // type: 'custom',
        // bulletClass:'my-bullet',
        // bulletActiveClass:'my-activeBullet',
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // 如果需要滚动条
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      on: {
        slideChangeTransitionEnd: function () {
          _this.setState({
            curSwiperIndex: this.realIndex//切换结束时，告诉我现在是第几个slide
          })
          var cur = _this.state.data.content[this.realIndex];
          var cur_w = parseFloat(cur.width);
          var cur_h = parseFloat(cur.height);
          var h = cur_h / cur_w * 7.5
          $('#subject_swiper').css({
            height: h + 'rem'
          })
        },
      },
    })
  }

  // 将富文本中的a标签链接替换为当前环境的链接
  replaceHref() {
    console.log("888888888")
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        //替换
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article': // 文章
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video': // 视频
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live': // 直播
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays': // 图说
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial': // 常规专题
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial': // 时间线专题
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial': // 新型专题
            new_href += 'newSubject' + obj.uuid;
            break;
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }
  // 替换富文本中的单位
  replacRem(content) {
    for (var i = 10; i < 50; i++) {
      var px = i + 'px';
      var rem = i / 100 * 2 + 'rem'
      content = content.replace(new RegExp(px, 'g'), rem)
    }
    return content
  }

  // 统计
  statistics(share) {
    var op = share ? 'share' : 'pv';
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=web&unique_id=' + this.state.uuid;     //填自己的js路径
    $('body').append(script);
  }

  initWx(obj) {
    //分享
    var wxconfig = new window.WxConfig();
    console.log(window.location.href);
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: API.share_img,
      successCallback: this.statistics.bind(this, true)
    });
  }

  // 切换音频播放倍数
  changeSpeed = (speed) => {
    this.setState({
      curSelectSpeed:speed
    })
    let audioEle = this.refs.audioDom
    audioEle.playbackRate = speed;
  }

  // 切换音频播放、暂停
  togglePlayStatus = () => {
    this.setState({
      audioPlayStatus:!this.state.audioPlayStatus
    },() => {
      if(this.state.audioPlayStatus){
        this.refs.audioDom.play()
      } else {
        this.refs.audioDom.pause()
      }
    })
  }

  // 改变音频滑块
  changeAudioSlider = (value) => {
    this.setState({
      audioCurTime:value
    },() => {
      let audioEle = this.refs.audioDom
      audioEle.currentTime = value
    })
  }

  // 音频稿件
  // 音频开始
  audioStart = () => {
    var _this = this
    this.state.playerName && this.state.playerName.play()
    const {stateName} = this.state;
    if(stateName === 'notStarted'){
      this.setState({
        stateName: 'start'
      })
    }else if(stateName === 'start'){
      this.setState({
        stateName: 'suspend'
      })
    }else {
      this.setState({
        stateName: 'start'
      })
    }
    
    
    setin = setInterval(function(){
        // var getCurrentTime = player.getCurrentTime()
        var getCurrentTime = _this.state.playerName.getCurrentTime && _this.state.playerName.getCurrentTime()

        // var in_tuola_jindu_dian = document.getElementsByClassName('in_tuola_jindu_dian')[0];
        // var in_tuola_jindu_xian = document.getElementsByClassName('in_tuola_jindu_xian')[0];
        var obj = document.getElementsByTagName('html')[0];
        var font_si = parseFloat(window.getComputedStyle(obj, '').getPropertyValue("font-size"));
        var width = $('.in_tuola_jindu').width() - 6;

        // console.log(getCurrentTime)
        var min=Math.floor(getCurrentTime%3600);
        //  Math.floor(getCurrentTime/3600) + "时" + 
        // var fenm =Math.floor(min/60) + ":"+ (Math.floor(getCurrentTime%60) < 10 ? '0' + Math.floor(getCurrentTime%60) : Math.floor(getCurrentTime%60));
        var fenm =Math.floor(min/60) + ":"+ (Math.round(getCurrentTime%60) < 10 ? '0' + Math.round(getCurrentTime%60) : Math.round(getCurrentTime%60));
        document.getElementsByClassName('in_tuola_left')[0].innerText = fenm;
        // console.log(fenm)
        // var getC_pla = getCurrentTime / window.player_getDur * 100 ;
        var getC_pla = getCurrentTime / _this.state.playerName.getDuration() * 100 ;
        document.getElementsByClassName('in_tuola_jindu_xian')[0].style.width = (width * getC_pla / 100 / font_si) +'rem';
        document.getElementsByClassName('in_tuola_jindu_dian')[0].style.left = (width * getC_pla / 100 / font_si) +'rem';
        // $('.in_tuola_jindu_xian').width(width*getC_pla/100);
        // $('.in_tuola_jindu_dian').css({
        //     left: width*getC_pla/100
        // });
    },1000)
  }
  // 音频暂停
  audioSuspend = () => {
    this.state.playerName && this.state.playerName.pause();
    setin&&clearInterval(setin)
    const {stateName} = this.state;
    if(stateName === 'notStarted'){
      this.setState({
        stateName: 'start'
      })
    }else if(stateName === 'start'){
      this.setState({
        stateName: 'suspend'
      })
    }else {
      this.setState({
        stateName: 'start'
      })
    }
  }
  titleSwitchFun = () => {
    const {titleSwitch} = this.state;
    this.setState({
      titleSwitch: !titleSwitch
    })
  }
  openApp1=()=>{
    console.log(this.props)
    const {uuid} = this.state.data
    const {name} = this.state
    console.log(name, uuid,'data')
    // var download_url = 'https://bj-dongcheng.oss-cn-beijing.aliyuncs.com/package/2020/12/16/5003313083700028486.apk'
    // var ios_app_url = 'https://apps.apple.com/cn/app/%E5%8C%97%E4%BA%AC%E4%B8%9C%E5%9F%8E/id1459595192'
    // var ios_download_url = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
    var ios_url = 'com.foundaoDongCheng://'
    var android_url = 'com.foundao.dongcheng://bjnews.com/action?'
    const iosUrl = ios_url + name + '/' + uuid
    const androidUrl = android_url + 'name=' + name + '&uuid=' + uuid
    console.log(androidUrl)

    if (this._isWeiXin()) {   //判断是否是在微信中打开
      // this.openAppInWeixin(iosUrl, androidUrl)
      this.props.history.push(`/middlePage/url=${this.userAgent() === 0 ? iosUrl : androidUrl}`)

    } else {
      var userAgent = this.userAgent()
      if (userAgent === 0) {   //ios环境
        window.location.href = iosUrl
        var last = Date.now()
        // return false
        //程序切换到后台，计时器会被推迟
        setTimeout( () => {
          if (Date.now() - last <= 2000) {
            //唤起失败，进入下载页
            // window.location.href = download_url;
            // const wxBrowser = <div className='browserContainer' onClick={this.test}>
            //               <div className="content">
            //                 <div className="logoBox"><div></div></div>
            //                 <div className="title">北京东城客户端</div>
            //                 <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
            //                 <div className="download">
            //                   <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = ios_app_url}}></div>
            //                 </div>
            //               </div>
            //             </div>
            // ReactDOM.render(wxBrowser, document.getElementById('root'));
            this.props.history.push(`/middlePage/url=${iosUrl}`)
          }
        }, 1600)
        // setTimeout(function () {
        //   window.location.href = ios_download_url
        // }, 2000)
      } else if (userAgent === 1) {  // 安卓环境
        window.location.href = androidUrl
        var last = Date.now()
        // return false
        //程序切换到后台，计时器会被推迟
        setTimeout( () => {
          if (Date.now() - last <= 2000) {
            //唤起失败，进入下载页
            // window.location.href = download_url;
            // const wxBrowser = <div className='browserContainer' onClick={this.test}>
            //               <div className="content">
            //                 <div className="logoBox"><div></div></div>
            //                 <div className="title">北京东城客户端</div>
            //                 <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
            //                 <div className="download">
            //                   <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = download_url}}></div>
            //                 </div>
            //               </div>
            //             </div>
            // ReactDOM.render(wxBrowser, document.getElementById('root'));
            this.props.history.push(`/middlePage/url=${androidUrl}`)
          }
        }, 1600)
      } 
    }
  }
  // 判断是安卓还是苹果
  userAgent = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 0;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 1;
    }
  };
  // 判断链接是不是在微信中打开
  _isWeiXin = () => {
    return /micromessenger/.test(navigator.userAgent.toLowerCase());
  };

  render() {
    const {data, type} = this.state;

    return (
      <div className="detail-box">

        {/*头部*/}
        <Header name={this.state.name} uuid={this.state.uuid}/>

        {/* 根据类型获取富文本并渲染 */}
        {this.getHtml()}

        {/*打开APP按钮*/}
        <AppBtn name={this.state.name}
                uuid={this.state.uuid}
                text={data.ballot_info ? "打开北京东城App，参与活动投票" : "打开北京东城App，阅读体验更佳"}/>

        {/*评论*/}
        {/* {
          type === DETAIL_TYPE.SWIPER ? ('') : (
            data.hasOwnProperty('comment_list') && (data.comment_list.hot_comment.length !== 0) ? (
              <div>
                <div className="comment-box">
                  <div className="comment-title">热门评论</div>
                  <div className="comment-list">
                    {
                      data.hasOwnProperty('comment_list') ? (data.comment_list.hot_comment.map((item, index) => {
                        return (
                          <div className="comment-item" key={index}>
                            <div className="left">
                              <div className="head-img" style={{
                                backgroundImage: 'url(' + item.head_image + ')'
                              }}/>
                            </div>
                            <div className="right">
                              <div className="name">{item.user_name}</div>
                              <div className="time">{item.add_time}</div>
                              <div className="content">{item.content}</div>
                            </div>
                          </div>
                        )
                      })) : ('')
                    }
                  </div>
                </div>
                <AppBtn style={{
                  marginTop: '.35rem'
                }} text="打开新京报App，参与评论"/>
              </div>
            ) : ('')
          )
        } */}
        <TopBtn type={1}/>

      </div>
    );
  }
}

export default Detail;


// WEBPACK FOOTER //
// ./src/pages/Detail/detail.js